export enum ReviewProviderEnum {
  GOOGLE_REVIEWS = "GOOGLE_REVIEWS",
  TRUSTPILOT = "TRUSTPILOT",
}
